export default "__VITE_ASSET__NrG2b_J_6HvlEa0ROyE6jg__"